export default __webpack_public_path__ + "static/media/Mondstadt Theme (Night).8aa142e0.mp3";